/*=========================================================================================
  File Name: module-licenseinfo-getters.js
  Description: LicenseInfo Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import commonFunc from '@/common/commonFunction';
export default {
	SumanLicenseInfo: state => {
		return state.SumanLicenseInfo;
	},
	licenseInfo: state => {
		return state.licenseInfo;
	},
	PaymentStatus: function(state) {
		return commonFunc.getDataFromEnum('PaymentStatus');
	},
	OrderList: state => {
		return state.OrderList;
	},
	TotalOrderList: state => {
		return state.TotalOrderList;
	}
};
